import {createSelector} from 'reselect';
import getBasketContainsSubscriptionProduct from '../../getBasketContainsSubscriptionProduct';
import {getSettings} from '../../selectors';

export default createSelector(
  [getSettings, getBasketContainsSubscriptionProduct],
  (settings, basketContainsSubscriptionProduct) => {
    const allowedCardBrandsForSubscriptions = settings?.adyen_v2_allowed_card_brands_for_subscription || [];
    const adyenV2PaymentMethodsConfiguration = settings.adyen_v2_payment_methods_configuration;
    
    if (basketContainsSubscriptionProduct && allowedCardBrandsForSubscriptions.length) {
      let newAdyenV2PaymentMethodsConfigurationForCard;
      if (adyenV2PaymentMethodsConfiguration?.card) {
        newAdyenV2PaymentMethodsConfigurationForCard = {...adyenV2PaymentMethodsConfiguration?.card, brands: allowedCardBrandsForSubscriptions};
      } else {
        newAdyenV2PaymentMethodsConfigurationForCard = {brands: allowedCardBrandsForSubscriptions};
      }
      
      return {...adyenV2PaymentMethodsConfiguration, card: newAdyenV2PaymentMethodsConfigurationForCard};
    }
    
    return adyenV2PaymentMethodsConfiguration;
  },
);
